module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Grace Thompson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Grace Thompson is a much-loved Welsh author of saga and romance novels, and a mainstay of libraries throughout the United Kingdom and beyond.")]), _c('P', [_vm._v("Born and raised in South Wales, she is the author of numerous series, including the Valley series, the Pendragon Island series, and the Badger’s Brook series. She published her 42nd novel shortly after celebrating her 80th birthday, and continues to live in Swansea.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AuNYsu/tc-custom/9781911591023.jpg?1718282658691",
      "alt": "This image is the cover for the book Homecoming"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Homecoming\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In post–WWII Wales, a young woman must put aside her broken heart—and focus on unearthing a killer’s secrets . . .")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The war is over, and life seems simple for Lydia—she’s working at the Swansea market and waiting for her sweetheart, Glyn, to come home from the navy and marry her. Her only hardship at the moment is attending to her needy mother, who complains constantly of vague ailments. But when Glyn returns, he leaves Lydia for another woman. Soon after, the mysterious Matthew reappears after sixteen years away. Is he a dangerous stranger, or the perfect cure for a broken heart?"), _c('br'), _c('br'), _vm._v(" Meanwhile, a body is found buried in the grounds of the centuries-old ruined castle that looms over the town, and the community is thrown into disarray. Who among them would stoop to murder? And why? Can the people of Swansea trust each other? Everyone seems to have something to hide, and Lydia is determined to get to the bottom of the mystery. But she has no idea how far the killer will go to keep a secret, and next time the victim could be even closer to home . . . ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0